import React from "react";
import "./output.css";

export default function Output({ fileContent }) {
    const handleExport = (format) => {
      let mimeType = "text/plain"; // Default type
      let fileName = `exported_file.${format}`;
  
      switch (format) {
        case "dwg":
          mimeType = "application/acad";
          break;
        case "dxf":
          mimeType = "application/dxf";
          break;
        case "jpg":
          mimeType = "image/jpeg";
          break;
        case "geotiff":
          mimeType = "image/tiff";
          break;
        default:
          mimeType = "text/plain";
      }
  
      const blob = new Blob([fileContent], { type: mimeType });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    };
  
    return (
      <div className="output-container">
        <h3>Export File</h3>
        <div className="btn-group">
          <button onClick={() => handleExport("dwg")} className="btn btn-primary">Export as DWG</button>
          <button onClick={() => handleExport("dxf")} className="btn btn-primary">Export as DXF</button>
          <button onClick={() => handleExport("jpg")} className="btn btn-primary">Export as JPG</button>
          <button onClick={() => handleExport("geotiff")} className="btn btn-primary">Export as GeoTIFF</button>
        </div>
      </div>
    );
  }
  